import { render, staticRenderFns } from "./MapelMateri.vue?vue&type=template&id=3eb2935a"
import script from "./MapelMateri.vue?vue&type=script&lang=js"
export * from "./MapelMateri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports